const openQuickShopModal = (product) => {
  if (product?.handle) {
    window.loadQuickview({ url: `/products/${product.handle}` });
  }
};

//This Function is for the onClick Function on Tolstoy Spotlight Carousel "+" button
const subscribeToQuickShopClick = () => {
  window.tolstoyWidget.subscribe(
    "tolstoy_spotlight_carousel_quick_shop_click",
    (o) => {
      o.product && o.product.handle
        ? openQuickShopModal(o.product)
        : console.error("Product handle is not available in the event");
    },
    { disableDefault: !0 }
  );
};

window.tolstoyWidget
  ? subscribeToQuickShopClick()
  : window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);

window.addEventListener('load', function () {
  addAriaLabelsToTolstoySvgs();
  addAriaLabelToQuickAddButtonSvgs();

  const carousel = document.querySelector('tolstoy-carousel');
  if (!carousel) return;

  const observedVideos = new Set();

  function attachVideoListeners(video) {
    if (observedVideos.has(video)) return;
    observedVideos.add(video);

    const container = video.closest('.tolstoy-carousel-video-container');
    const playButton = container?.querySelector('.tolstoy-play-button-container');

    video.addEventListener('play', () => {
      if (playButton) playButton.style.display = 'none';
    });

    video.addEventListener('pause', () => {
      if (playButton) playButton.style.display = '';
    });
  }

  // Initial scan (in case videos are already present)
  carousel.querySelectorAll('video').forEach(attachVideoListeners);

  // Watch for dynamically added videos
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.tagName === 'VIDEO') {
          attachVideoListeners(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('video').forEach(attachVideoListeners);
        }
      });
    });
  });

  observer.observe(carousel, {
    childList: true,
    subtree: true,
  });
});

function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

function addAriaLabelsToTolstoySvgs() {
  const svgLabelMap = {
    '._playIcon_6kg4i_106': 'Play Tolstoy video',
    '._pauseIcon_6kg4i_110': 'Pause Tolstoy video',
    '._unmuteSvg_1cxli_234': 'Unmute Tolstoy video',
    '._muteSvg_1cxli_224': 'Mute Tolstoy video',
  };

  Object.entries(svgLabelMap).forEach(([selector, label]) => {
    document.querySelectorAll(selector).forEach((svg) => {
      if (!svg.hasAttribute('aria-label')) {
        svg.setAttribute('role', 'img');
        svg.setAttribute('aria-label', label);
      }
    });
  });
}

function addAriaLabelToQuickAddButtonSvgs() {
  document.querySelectorAll('.tolstoy-product-tile-button svg').forEach((svg) => {
    if (!svg.hasAttribute('aria-label')) {
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', 'Add to cart');
    }
  });
}

function initLabels() {
  waitForElm(".tolstoy-carousel-controls-container").then((root) => {
    addAriaLabelsToTolstoySvgs();

    const reviewObserver = new MutationObserver(() => {
      addAriaLabelsToTolstoySvgs();
    });

    reviewObserver.observe(root, {
      childList: true,
      subtree: true,
    });
  });
}
